import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on home page
  if (pathnames.length === 0) return null;

  // Mapping for better display names
  const pathDisplayNames: Record<string, string> = {
    'services': 'Services',
    'general-contracting': 'General Contracting',
    'skilled-trades': 'Skilled Trades',
    'carpenter': 'Carpentry Services',
    'roofing': 'Roofing Services',
    'flooring': 'Flooring Services',
    'masonry': 'Masonry Services',
    'hvac': 'HVAC Services',
    'welding': 'Welding Services',
    'heavy-equipment': 'Heavy Equipment & Site Work',
    'specialty-contracting': 'Specialty Contracting',
    'design-engineering': 'Design & Engineering Support',
    'asphalt-paving': 'Asphalt Paving Services',
    'asphalt-paving-concrete': 'Asphalt, Paving & Concrete Work',
    'electrician': 'Electrician Services',
    'plumber': 'Plumber Services',
    'gallery': 'Project Gallery',
    'about': 'About Us',
    'contact': 'Contact Us',
    'locations': 'Service Areas',
    'toronto': 'Toronto',
    'ottawa': 'Ottawa',
    'mississauga': 'Mississauga',
    'hamilton': 'Hamilton',
    'london': 'London',
    'kitchener-waterloo': 'Kitchener-Waterloo',
    'careers': 'Careers',
    'bathroom-renovations': 'Bathroom Renovations',
    'kitchen-renovations': 'Kitchen Renovations'
  };

  return (
    <div className="bg-muted/50 border-b border-border">
      <div className="container mx-auto px-4 py-3">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/" className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors">
                  <Home className="h-4 w-4" />
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            
            {pathnames.map((pathname, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;
              const displayName = pathDisplayNames[pathname] || pathname.charAt(0).toUpperCase() + pathname.slice(1);

              return (
                <div key={pathname} className="flex items-center">
                  <BreadcrumbSeparator>
                    <ChevronRight className="h-4 w-4" />
                  </BreadcrumbSeparator>
                  <BreadcrumbItem>
                    {isLast ? (
                      <BreadcrumbPage className="text-foreground font-medium">
                        {displayName}
                      </BreadcrumbPage>
                    ) : (
                      <BreadcrumbLink asChild>
                        <Link 
                          to={routeTo}
                          className="text-muted-foreground hover:text-primary transition-colors"
                        >
                          {displayName}
                        </Link>
                      </BreadcrumbLink>
                    )}
                  </BreadcrumbItem>
                </div>
              );
            })}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  );
};

export default Breadcrumbs;